export const exportedVideoName = (): string => `piece-${Date.now()}.mp4`;
